module.exports = __webpack_public_path__ + "img/news-06.e6d3a1f6.jpg";